import {
    Component, ElementRef,
    EventEmitter,
    forwardRef,
    Input,
    Output
} from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ModalController } from 'ionic-angular';
import * as fromRoot from '../../../store/bootstrap';
import { ControlComponent } from '../../control.component';
import { MembershipControl } from '../membership-control.model';
import { MembershipControlModalComponent } from './membership-control-modal.component';

@Component({
    selector: 'membership',
    template: `
        <button ion-button (click)="showMembershipModal()">Manage</button>
    `,
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MembershipControlComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => MembershipControlComponent), multi: true}
    ],
    entryComponents: [MembershipControlModalComponent]
})
export class MembershipControlComponent extends ControlComponent implements ControlValueAccessor {
    @Input() definition: MembershipControl;
    @Input() formControl: FormControl;
    @Input() formGroup: FormGroup;
    @Output() changes: EventEmitter<any> = new EventEmitter();
    @Input('value') _value: string;

    constructor(
        protected elemRef: ElementRef,
        protected modalCtl: ModalController,
        protected store: Store<fromRoot.State>
    ) {
        super(elemRef);
    }

    showMembershipModal(): void {

        console.log('membership field', this.formGroup, this.value);

        const modal = this.modalCtl.create(MembershipControlModalComponent, {
            definition: this.definition,
            userId: this.formGroup.get(['editUser', 'id']).value
        });

        modal.onDidDismiss(value => {
            this.updateValue(value);
        });

        modal.present();

        return;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/membership/form/membership-control.component.ts